/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const logEvent = /* GraphQL */ `
  mutation LogEvent($eventType: String!, $eventMessage: String) {
    logEvent(eventType: $eventType, eventMessage: $eventMessage)
  }
`;
export const scheduleApIcreatePostedSchedule = /* GraphQL */ `
  mutation ScheduleApIcreatePostedSchedule(
    $resourcesCollectionId: Int!
    $startDate: String!
    $format: Int!
    $userId: Int!
    $liveScheduleInput: liveScheduleInput!
    $allResourcesList: String!
    $ipAddress: String!
  ) {
    scheduleAPIcreatePostedSchedule(
      resourcesCollectionId: $resourcesCollectionId
      startDate: $startDate
      format: $format
      userId: $userId
      liveScheduleInput: $liveScheduleInput
      allResourcesList: $allResourcesList
      ipAddress: $ipAddress
    )
  }
`;
export const tourApIcreateTour = /* GraphQL */ `
  mutation TourApIcreateTour(
    $resourceId: Int!
    $dateTimeStartActual: String!
    $dateTimeEndActual: String!
    $unionId: Int!
    $contractId: Int!
    $contractRulesGroupId: Int!
    $timeZoneId: Int!
    $createDefaultMeal: Boolean!
    $userId: Int!
    $comment: String
    $comment15: String
    $notification: String
    $showBusy: Boolean!
    $IPAddress: String!
    $baseRateId: Int!
    $baseOverrideType: String!
    $baseOverride: Float!
    $jobSalaryId: Int!
  ) {
    tourAPIcreateTour(
      resourceId: $resourceId
      dateTimeStartActual: $dateTimeStartActual
      dateTimeEndActual: $dateTimeEndActual
      unionId: $unionId
      contractId: $contractId
      contractRulesGroupId: $contractRulesGroupId
      timeZoneId: $timeZoneId
      createDefaultMeal: $createDefaultMeal
      userId: $userId
      comment: $comment
      comment15: $comment15
      notification: $notification
      showBusy: $showBusy
      IPAddress: $IPAddress
      baseRateId: $baseRateId
      baseOverrideType: $baseOverrideType
      baseOverride: $baseOverride
      jobSalaryId: $jobSalaryId
    ) {
      status
      tourId
    }
  }
`;
export const tourApIdeleteTour = /* GraphQL */ `
  mutation TourApIdeleteTour(
    $tourId: String!
    $userId: Int!
    $IPAddress: String!
  ) {
    tourAPIdeleteTour(tourId: $tourId, userId: $userId, IPAddress: $IPAddress) {
      status
    }
  }
`;
export const tourApIupdateTour = /* GraphQL */ `
  mutation TourApIupdateTour(
    $tourId: String!
    $resourceId: Int!
    $dateTimeStartActual: String!
    $dateTimeEndActual: String!
    $unionId: Int!
    $contractId: Int!
    $contractRulesGroupId: Int!
    $salaryLevelId: Int!
    $timeZoneId: Int!
    $userId: Int!
    $comment: String
    $comment15: String
    $notification: String
    $showBusy: Boolean!
    $IPAddress: String!
    $postTK: Boolean!
    $TKComment: String
    $baseRateId: Int!
    $baseOverrideType: String!
    $baseOverride: Float!
    $jobSalaryId: Int!
    $jobSalaryUpgradeId: Int!
    $approverComment: String
    $reconciled: Boolean
  ) {
    tourAPIupdateTour(
      tourId: $tourId
      resourceId: $resourceId
      dateTimeStartActual: $dateTimeStartActual
      dateTimeEndActual: $dateTimeEndActual
      unionId: $unionId
      contractId: $contractId
      contractRulesGroupId: $contractRulesGroupId
      salaryLevelId: $salaryLevelId
      timeZoneId: $timeZoneId
      userId: $userId
      comment: $comment
      comment15: $comment15
      notification: $notification
      showBusy: $showBusy
      IPAddress: $IPAddress
      postTK: $postTK
      TKComment: $TKComment
      baseRateId: $baseRateId
      baseOverrideType: $baseOverrideType
      baseOverride: $baseOverride
      jobSalaryId: $jobSalaryId
      jobSalaryUpgradeId: $jobSalaryUpgradeId
      approverComment: $approverComment
      reconciled: $reconciled
    ) {
      status
    }
  }
`;
export const tourApIcreateTourActivityFlag = /* GraphQL */ `
  mutation TourApIcreateTourActivityFlag(
    $tourId: Int!
    $activityFlagId: Int!
    $jobElementId: Int!
    $startTime: String!
    $endTime: String!
    $updatingUserId: Int!
    $IPAddress: String!
  ) {
    tourAPIcreateTourActivityFlag(
      tourId: $tourId
      activityFlagId: $activityFlagId
      jobElementId: $jobElementId
      startTime: $startTime
      endTime: $endTime
      updatingUserId: $updatingUserId
      IPAddress: $IPAddress
    ) {
      status
    }
  }
`;
export const tourApIcreateTourIndicator = /* GraphQL */ `
  mutation TourApIcreateTourIndicator(
    $codeId: Int!
    $indicatorId: Int!
    $tourId: Int!
    $updatingUserId: Int!
    $billable: Boolean!
    $jobElementId: Int!
    $cost: Float!
  ) {
    tourAPIcreateTourIndicator(
      codeId: $codeId
      indicatorId: $indicatorId
      tourId: $tourId
      updatingUserId: $updatingUserId
      billable: $billable
      jobElementId: $jobElementId
      cost: $cost
    ) {
      status
    }
  }
`;
export const tourApIcreateTourPayTransaction = /* GraphQL */ `
  mutation TourApIcreateTourPayTransaction(
    $tourId: Int!
    $payTransactionId: Int!
    $units: Int!
    $jobElementId: Int!
    $waived: Boolean!
    $billable: Boolean!
    $internalRemark: String!
    $remark: String!
    $timeKeeperComment: String!
    $updatingUserId: Int!
    $IPAddress: String!
    $baseRate: Float!
  ) {
    tourAPIcreateTourPayTransaction(
      tourId: $tourId
      payTransactionId: $payTransactionId
      units: $units
      jobElementId: $jobElementId
      waived: $waived
      billable: $billable
      internalRemark: $internalRemark
      remark: $remark
      timeKeeperComment: $timeKeeperComment
      updatingUserId: $updatingUserId
      IPAddress: $IPAddress
      baseRate: $baseRate
    ) {
      status
    }
  }
`;
export const tourApIdeleteTourActivityFlag = /* GraphQL */ `
  mutation TourApIdeleteTourActivityFlag(
    $tourActivityFlagId: Int!
    $updatingUserId: Int!
    $IPAddress: String!
  ) {
    tourAPIdeleteTourActivityFlag(
      tourActivityFlagId: $tourActivityFlagId
      updatingUserId: $updatingUserId
      IPAddress: $IPAddress
    ) {
      status
    }
  }
`;
export const tourApIdeleteTourIndicator = /* GraphQL */ `
  mutation TourApIdeleteTourIndicator($tourIndicatorId: Int!) {
    tourAPIdeleteTourIndicator(tourIndicatorId: $tourIndicatorId) {
      status
    }
  }
`;
export const tourApIdeleteTourPayTransaction = /* GraphQL */ `
  mutation TourApIdeleteTourPayTransaction(
    $tourPayTransactionId: Int!
    $updatingUserId: Int!
    $IPAddress: String!
  ) {
    tourAPIdeleteTourPayTransaction(
      tourPayTransactionId: $tourPayTransactionId
      updatingUserId: $updatingUserId
      IPAddress: $IPAddress
    ) {
      status
    }
  }
`;
export const tourApIupdateTourActivityFlag = /* GraphQL */ `
  mutation TourApIupdateTourActivityFlag(
    $tourActivityFlagId: Int!
    $tourId: Int!
    $activityFlagId: Int!
    $jobElementId: Int!
    $startTime: String!
    $endTime: String!
    $updatingUserId: Int!
    $IPAddress: String!
  ) {
    tourAPIupdateTourActivityFlag(
      tourActivityFlagId: $tourActivityFlagId
      tourId: $tourId
      activityFlagId: $activityFlagId
      jobElementId: $jobElementId
      startTime: $startTime
      endTime: $endTime
      updatingUserId: $updatingUserId
      IPAddress: $IPAddress
    ) {
      status
    }
  }
`;
export const tourApIupdateTourIndicator = /* GraphQL */ `
  mutation TourApIupdateTourIndicator(
    $tourIndicatorId: Int!
    $tourId: Int!
    $codeId: Int!
    $indicatorId: Int!
    $updatingUserId: Int!
    $billable: Boolean!
    $jobElementId: Int!
    $cost: Float!
  ) {
    tourAPIupdateTourIndicator(
      tourIndicatorId: $tourIndicatorId
      tourId: $tourId
      codeId: $codeId
      indicatorId: $indicatorId
      updatingUserId: $updatingUserId
      billable: $billable
      jobElementId: $jobElementId
      cost: $cost
    ) {
      status
    }
  }
`;
export const tourApIupdateTourPayTransaction = /* GraphQL */ `
  mutation TourApIupdateTourPayTransaction(
    $tourPayTransactionId: Int!
    $tourId: Int!
    $payTransactionId: Int!
    $units: Int!
    $jobElementId: Int!
    $waived: Boolean!
    $billable: Boolean!
    $internalRemark: String!
    $remark: String!
    $timeKeeperComment: String!
    $updatingUserId: Int!
    $IPAddress: String!
    $baseRate: Float!
  ) {
    tourAPIupdateTourPayTransaction(
      tourPayTransactionId: $tourPayTransactionId
      tourId: $tourId
      payTransactionId: $payTransactionId
      units: $units
      jobElementId: $jobElementId
      waived: $waived
      billable: $billable
      internalRemark: $internalRemark
      remark: $remark
      timeKeeperComment: $timeKeeperComment
      updatingUserId: $updatingUserId
      IPAddress: $IPAddress
      baseRate: $baseRate
    ) {
      status
    }
  }
`;
export const dayTypeApIcreateResourceDayType = /* GraphQL */ `
  mutation DayTypeApIcreateResourceDayType(
    $date: String!
    $dayTypeId: Int!
    $resourceId: Int!
    $comment: String
    $myComment: String
    $userId: Int!
    $IPAddress: String!
    $TKComment: String
  ) {
    dayTypeAPIcreateResourceDayType(
      date: $date
      dayTypeId: $dayTypeId
      resourceId: $resourceId
      comment: $comment
      myComment: $myComment
      userId: $userId
      IPAddress: $IPAddress
      TKComment: $TKComment
    ) {
      status
      resourceDayTypeId
    }
  }
`;
export const dayTypeApIupdateResourceDayType = /* GraphQL */ `
  mutation DayTypeApIupdateResourceDayType(
    $date: String!
    $dayTypeId: Int!
    $resourceId: Int
    $approved: Boolean!
    $comment: String
    $myComment: String
    $daysRequestId: Int!
    $userId: Int!
    $unionId: Int!
    $contractId: Int!
    $contractRulesGroupId: Int!
    $salaryLevelId: Int!
    $IPAddress: String!
    $TKComment: String
    $jobSalaryId: Int!
    $hourlyActivityRateFlag: Boolean!
    $rate: Float!
    $jobSalaryUpgradeId: Int!
    $resourceDayTypeId: String!
  ) {
    dayTypeAPIupdateResourceDayType(
      date: $date
      dayTypeId: $dayTypeId
      resourceId: $resourceId
      approved: $approved
      comment: $comment
      myComment: $myComment
      daysRequestId: $daysRequestId
      userId: $userId
      unionId: $unionId
      contractId: $contractId
      contractRulesGroupId: $contractRulesGroupId
      salaryLevelId: $salaryLevelId
      IPAddress: $IPAddress
      TKComment: $TKComment
      jobSalaryId: $jobSalaryId
      hourlyActivityRateFlag: $hourlyActivityRateFlag
      rate: $rate
      jobSalaryUpgradeId: $jobSalaryUpgradeId
      resourceDayTypeId: $resourceDayTypeId
    ) {
      status
      dontKnowWhatIdThisIs
    }
  }
`;
export const dayTypeApIupdateResourceDayTypeComment = /* GraphQL */ `
  mutation DayTypeApIupdateResourceDayTypeComment(
    $resourceDayTypeId: String!
    $userId: Int!
    $myComment: String
    $IPAddress: String!    
  ) {
    dayTypeAPIupdateResourceDayTypeComment(
      resourceDayTypeId: $resourceDayTypeId
      userId: $userId
      myComment: $myComment
      IPAddress: $IPAddress
    ) {
      status
      dontKnowWhatIdThisIs
    }
  }
`;
export const mealApIcreateMeal = /* GraphQL */ `
  mutation MealApIcreateMeal(
    $tourId: String!
    $startTime: String!
    $endTime: String!
    $userId: Int!
    $IPAddress: String!
  ) {
    mealAPIcreateMeal(
      tourId: $tourId
      startTime: $startTime
      endTime: $endTime
      userId: $userId
      IPAddress: $IPAddress
    ) {
      status
      mealId
    }
  }
`;
export const mealApIupdateMeal = /* GraphQL */ `
  mutation MealApIupdateMeal(
    $tourId: String!
    $mealId: String!
    $startTime: String!
    $endTime: String!
    $userId: Int!
    $IPAddress: String!
    $jobElementId: Int!
    $OTE: Boolean!
    $billable: Boolean!
    $autoAdd: Boolean!
  ) {
    mealAPIupdateMeal(
      tourId: $tourId
      mealId: $mealId
      startTime: $startTime
      endTime: $endTime
      userId: $userId
      IPAddress: $IPAddress
      jobElementId: $jobElementId
      OTE: $OTE
      billable: $billable
      autoAdd: $autoAdd
    ) {
      status
      mealId
    }
  }
`;
export const mealApIdeleteMeal = /* GraphQL */ `
  mutation MealApIdeleteMeal(
    $mealId: Int!
    $updatingUserId: Int!
    $IPAddress: String!
  ) {
    mealAPIdeleteMeal(
      mealId: $mealId
      updatingUserId: $updatingUserId
      IPAddress: $IPAddress
    ) {
      status
    }
  }
`;
export const dayTypeApIdeleteDayTypeRequests = /* GraphQL */ `
  mutation DayTypeApIdeleteDayTypeRequests($dayTypeRequestId: Int!) {
    dayTypeAPIdeleteDayTypeRequests(dayTypeRequestId: $dayTypeRequestId)
  }
`;
export const dayTypeApIdeleteResourceDayTypes = /* GraphQL */ `
  mutation DayTypeApIdeleteResourceDayTypes(
    $resourceId: Int!
    $fromDate: String!
    $toDate: String!
    $userId: Int!
    $IPAddress: String!
  ) {
    dayTypeAPIdeleteResourceDayTypes(
      resourceId: $resourceId
      fromDate: $fromDate
      toDate: $toDate
      userId: $userId
      IPAddress: $IPAddress
    ) {
      status
    }
  }
`;
export const dayTypeApIdeleteResourceDayType = /* GraphQL */ `
  mutation DayTypeApIdeleteResourceDayType(
    $id: Int!
    $updatingUserId: Int!
    $IPAddress: String!
  ) {
    dayTypeAPIdeleteResourceDayType(
      id: $id
      updatingUserId: $updatingUserId
      IPAddress: $IPAddress
    ) {
      status
    }
  }
`;
export const dayTypeApIcreateDayTypeRequests = /* GraphQL */ `
  mutation DayTypeApIcreateDayTypeRequests(
    $resourceId: Int!
    $dayTypeId: Int!
    $requestDate: String!
    $fromDate: String!
    $toDate: String!
    $fromTime: String
    $toTime: String
    $remark: String
    $status: String!
    $statusRemark: String
    $comment: String
    $userId: Int!
    $ipAddress: String!
  ) {
    dayTypeAPIcreateDayTypeRequests(
      resourceId: $resourceId
      dayTypeId: $dayTypeId
      requestDate: $requestDate
      fromDate: $fromDate
      toDate: $toDate
      fromTime: $fromTime
      toTime: $toTime
      remark: $remark
      status: $status
      statusRemark: $statusRemark
      comment: $comment
      userId: $userId
      ipAddress: $ipAddress
    ) {
      resourceId
      dayTypeId
      requestDate
      fromDate
      toDate
      fromTime
      toTime
      remark
      status
      statusRemark
      comment
      userId
      ipAddress
      id
    }
  }
`;
export const dayTypeApIupdateDayTypeRequests = /* GraphQL */ `
  mutation DayTypeApIupdateDayTypeRequests(
    $resourceId: Int!
    $dayTypeId: Int!
    $requestDate: String!
    $fromDate: String!
    $toDate: String!
    $fromTime: String
    $toTime: String
    $remark: String
    $status: String!
    $statusRemark: String
    $comment: String
    $userId: Int!
    $ipAddress: String!
    $id: Int!
  ) {
    dayTypeAPIupdateDayTypeRequests(
      resourceId: $resourceId
      dayTypeId: $dayTypeId
      requestDate: $requestDate
      fromDate: $fromDate
      toDate: $toDate
      fromTime: $fromTime
      toTime: $toTime
      remark: $remark
      status: $status
      statusRemark: $statusRemark
      comment: $comment
      userId: $userId
      ipAddress: $ipAddress
      id: $id
    ) {
      resourceId
      dayTypeId
      requestDate
      fromDate
      toDate
      fromTime
      toTime
      remark
      status
      statusRemark
      comment
      userId
      ipAddress
      id
    }
  }
`;
export const assignmentApIcreateJob = /* GraphQL */ `
  mutation AssignmentApIcreateJob(
    $creatingUserId: Int!
    $updatingUserId: Int!
    $costObjectId: Int!
    $costObjectTypeId: Int!
    $jobTitle: String!
    $baseDate: String!
    $IPAddress: String!
    $startRequest: String!
    $logControlId: Int!
  ) {
    assignmentAPIcreateJob(
      creatingUserId: $creatingUserId
      updatingUserId: $updatingUserId
      costObjectId: $costObjectId
      costObjectTypeId: $costObjectTypeId
      jobTitle: $jobTitle
      baseDate: $baseDate
      IPAddress: $IPAddress
      startRequest: $startRequest
      logControlId: $logControlId
    ) {
      status
      jobId
    }
  }
`;
export const assignmentApIcreateJobElement = /* GraphQL */ `
  mutation AssignmentApIcreateJobElement(
    $jobId: Int!
    $executingBranchId: Int!
    $tourId: Int!
    $serviceId: Int!
    $resourceId: Int!
    $relatedServiceId: Int!
    $status: Int
    $startRequest: String!
    $endRequest: String!
    $startActual: String!
    $endActual: String!
    $timeZoneId: Int!
    $orderingUserId: Int!
    $updatingUserId: Int!
    $comment: String
    $isAnUpgrade: Boolean!
    $logControlId: Int!
    $overTime: Boolean!
    $activityType: String!
    $IPAddress: String!
    $costObjectId: Int!
    $costObjectTypeId: Int!
    $jobSalaryUpgradeId: Int!
    $hourlyActivityRateFlag: Boolean!
    $rate: Float!
  ) {
    assignmentAPIcreateJobElement(
      jobId: $jobId
      executingBranchId: $executingBranchId
      tourId: $tourId
      serviceId: $serviceId
      resourceId: $resourceId
      relatedServiceId: $relatedServiceId
      status: $status
      startRequest: $startRequest
      endRequest: $endRequest
      startActual: $startActual
      endActual: $endActual
      timeZoneId: $timeZoneId
      orderingUserId: $orderingUserId
      updatingUserId: $updatingUserId
      comment: $comment
      isAnUpgrade: $isAnUpgrade
      logControlId: $logControlId
      overTime: $overTime
      activityType: $activityType
      IPAddress: $IPAddress
      costObjectId: $costObjectId
      costObjectTypeId: $costObjectTypeId
      jobSalaryUpgradeId: $jobSalaryUpgradeId
      hourlyActivityRateFlag: $hourlyActivityRateFlag
      rate: $rate
    ) {
      status
      jobElementId
    }
  }
`;
export const assignmentApIdeleteJob = /* GraphQL */ `
  mutation AssignmentApIdeleteJob(
    $jobId: Int!
    $userId: Int!
    $logControlId: Int!
  ) {
    assignmentAPIdeleteJob(
      jobId: $jobId
      userId: $userId
      logControlId: $logControlId
    ) {
      status
    }
  }
`;
export const assignmentApIdeleteJobElement = /* GraphQL */ `
  mutation AssignmentApIdeleteJobElement(
    $jobElementId: Int!
    $userId: Int!
    $logControlId: Int!
  ) {
    assignmentAPIdeleteJobElement(
      jobElementId: $jobElementId
      userId: $userId
      logControlId: $logControlId
    ) {
      status
    }
  }
`;
export const assignmentApIlogJobFinish = /* GraphQL */ `
  mutation AssignmentApIlogJobFinish($logControlId: Int!, $jobId: Int!) {
    assignmentAPIlogJobFinish(logControlId: $logControlId, jobId: $jobId) {
      status
    }
  }
`;
export const assignmentApIlogJobStart = /* GraphQL */ `
  mutation AssignmentApIlogJobStart($userId: Int!, $operation: Int!) {
    assignmentAPIlogJobStart(userId: $userId, operation: $operation) {
      status
      updatingDateTime
      logControlId
    }
  }
`;
export const assignmentApIupdateJob = /* GraphQL */ `
  mutation AssignmentApIupdateJob(
    $jobId: Int!
    $name: String!
    $jobNumber: Int!
    $creatingUserId: Int
    $updatingUserId: Int!
    $costObjectId: Int!
    $costObjectTypeId: Int!
    $GTitle: String!
    $GSchedulerComments: String
    $baseDate: String!
    $IPAddress: String!
    $startRequest: String!
    $endRequest: String!
    $GAdditionalInformation: String
    $logControlId: Int!
  ) {
    assignmentAPIupdateJob(
      jobId: $jobId
      name: $name
      jobNumber: $jobNumber
      creatingUserId: $creatingUserId
      updatingUserId: $updatingUserId
      costObjectId: $costObjectId
      costObjectTypeId: $costObjectTypeId
      GTitle: $GTitle
      GSchedulerComments: $GSchedulerComments
      baseDate: $baseDate
      IPAddress: $IPAddress
      startRequest: $startRequest
      endRequest: $endRequest
      GAdditionalInformation: $GAdditionalInformation
      logControlId: $logControlId
    ) {
      status
    }
  }
`;
export const userApIupdateUserHistory = /* GraphQL */ `
  mutation UserApIupdateUserHistory($resourceId: Int, $userId: Int) {
    userAPIupdateUserHistory(resourceId: $resourceId, userId: $userId) {
      status
    }
  }
`;
export const assignmentApIupdateJobElement = /* GraphQL */ `
  mutation AssignmentApIupdateJobElement(
    $jobId: Int!
    $executingBranchId: Int!
    $tourId: Int!
    $serviceId: Int!
    $resourceId: Int!
    $relatedServiceId: Int!
    $status: Int
    $startRequest: String!
    $endRequest: String!
    $startActual: String!
    $endActual: String!
    $timeZoneId: Int!
    $orderingUserId: Int!
    $updatingUserId: Int!
    $descriptionComment: String
    $approverComment: String
    $employeeComment: String
    $schedulerComment: String
    $isAnUpgrade: Boolean!
    $logControlId: Int!
    $overtime: Boolean!
    $activityType: String!
    $IPAddress: String!
    $overtimeType: Int!
    $overtimeReason: String
    $costObjectId: Int!
    $costObjectTypeId: Int!
    $jobSalaryUpgradeId: Int!
    $hourlyActivityRateFlag: Boolean!
    $rate: Float!
    $assignmentId: Int!
    $nabetTracker: Boolean!
    $eventNote: String!
    $skillShowId: Int!
    $skillFacilityId: Int!
    $chgTz: Boolean!
  ) {
    assignmentAPIupdateJobElement(
      jobId: $jobId
      executingBranchId: $executingBranchId
      tourId: $tourId
      serviceId: $serviceId
      resourceId: $resourceId
      relatedServiceId: $relatedServiceId
      status: $status
      startRequest: $startRequest
      endRequest: $endRequest
      startActual: $startActual
      endActual: $endActual
      timeZoneId: $timeZoneId
      orderingUserId: $orderingUserId
      updatingUserId: $updatingUserId
      descriptionComment: $descriptionComment
      approverComment: $approverComment
      employeeComment: $employeeComment
      schedulerComment: $schedulerComment
      isAnUpgrade: $isAnUpgrade
      logControlId: $logControlId
      overtime: $overtime
      activityType: $activityType
      IPAddress: $IPAddress
      overtimeType: $overtimeType
      overtimeReason: $overtimeReason
      costObjectId: $costObjectId
      costObjectTypeId: $costObjectTypeId
      jobSalaryUpgradeId: $jobSalaryUpgradeId
      hourlyActivityRateFlag: $hourlyActivityRateFlag
      rate: $rate
      assignmentId: $assignmentId
      nabetTracker: $nabetTracker
      eventNote: $eventNote
      skillShowId: $skillShowId
      skillFacilityId: $skillFacilityId
      chgTz: $chgTz
    ) {
      status
    }
  }
`;
export const approvalsApIupdateTourApprovals = /* GraphQL */ `
  mutation ApprovalsApIupdateTourApprovals(
    $tours: String!
    $tours2: String!
    $values: String!
    $jeIds: String!
    $jeIds2: String!
    $whatToDo: String!
    $userId: Int!
    $ipAddress: String!
    $unapprovedReason: String!
  ) {
    approvalsAPIupdateTourApprovals(
      tours: $tours
      tours2: $tours2
      values: $values
      jeIds: $jeIds
      jeIds2: $jeIds2
      whatToDo: $whatToDo
      userId: $userId
      ipAddress: $ipAddress
      unapprovedReason: $unapprovedReason
    ) {
      status
      errorMessages {
        type
        id
        error_msg
      }
    }
  }
`;
export const approvalsApIcreateTimeKeeperReversal = /* GraphQL */ `
  mutation ApprovalsApIcreateTimeKeeperReversal(
    $idFeed: String!
    $reversalReason: String!
    $approverId: String!
  ) {
    approvalsAPIcreateTimeKeeperReversal(
      idFeed: $idFeed
      reversalReason: $reversalReason
      approverId: $approverId
    ) {
      status
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations.js